<template>
<div>
    <div class="breadcrumbs" id="breadcrumbs">
        <span class="breadcrumb-link">Preferences</span> &gt;
        <router-link class="breadcrumb-link" to="/settings/integrations">Integrations</router-link>
    </div>
    <h3>Team External Integrations</h3>
      <div class="large-form">
        <div class="form-line">
            <div class="form-line-fields">
                <div class="form-field">
                    <label>CRM Integrations</label>
                    <table id="list-of-crm-integrations" class="worksends-table integrations-table inset">
                        <thead>
                        <tr>
                            <th>Platform</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr>
                            <td class="field-name">
                                <a href="https://www.hubspot.com/" target="_blank"><img src="/wp-content/themes/bookblock-shop/images/worksends/crm/hubspot.png" alt="HubSpot" /></a>
                                <div class="value">
                                    <p>An integrated platform of marketing, sales, customer service, operations, and CRM software designed to empower your team and help your business grow.</p>
                                </div>
                            </td>
                            <td class="field-status">
                                <div class="value" v-if="hubspot.status">{{ hubspot.status }}</div>
                                <div class="value" v-else><div class="value-loader"></div></div>
                            </td>
                            <td class="field-actions">
                                <div class="value">
                                    <div v-if="hubspot.status == 'disconnected' && hubspot.connectURL" @click="connectToHubspot()" class="ws-button ws-button-primary small">Connect</div>
                                    <div v-if="hubspot.status == 'connected'" @click="disconnectFromHubspot()" class="ws-button ws-button-negative small">Disconnect</div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </div>
            <div class="form-line-desc">
                <br><br>
                These are currently available CRM integrations that you can connect with your Bookblock HUB account.
            </div>
        </div>

        <div class="form-line">
            <div class="form-line-fields">
                <div class="form-field">
                    <label>API Keys</label>
                    <table id="list-of-api-keys" class="worksends-table integrations-table inset">
                        <thead>
                            <tr>
                                <th>Key Name</th>
                                <th>Token</th>
                                <th>Created</th>
                                <th>Last Used</th>
                                <th>Actions</th>
                            </tr>
                        </thead> 
                        <tbody>

                            <tr v-for="key in apiKeys.data">
                                <td class="field-name" style="min-width: 200px">
                                    <div class="value">{{ key.name }}</div>
                                </td>
                                <td class="field-token" style="width: 100px">
                                    <div class="value api-key">{{ key.preview }}</div>
                                </td>
                                <td class="field-created" style="width: 150px">
                                    <div class="value">{{ key.created_at }}</div>
                                </td>
                                <td class="field-last-used" style="width: 150px">
                                    <div class="value">{{ key.last_used_at }}</div>
                                </td>
                                <td class="field-actions">
                                    <div class="value">
                                        <div @click="deleteApiKey(key.id)" class="ws-button ws-button-negative small">Remove</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="form-field" style="width: 100%; margin-top: 10px;">
                    <div @click="openApiKeyModal" class="ws-button">Create New API Key</div>
                </div>
            </div>
            <div class="form-line-desc">
                <br><br>
                These keys will allow you to authenticate API requests from external services.
            </div>


        </div>
    </div>
    <api-key-modal v-if="modals.apiKeyModal"></api-key-modal>

</div>
</template>

<script>
import axios from 'axios';
import { alert, defaults } from '@pnotify/core';
import ApiKeyModal from '@/pages/settings/ApiKeyModal';

export default {
    name: "SettingsIntegrations",
    components: {ApiKeyModal},
    data() {
        return {
            masterKey: null,
            hubspot: {
                status: null,
                connectURL: '',
            }
        }
    },
    methods: {
        async connectToHubspot() {
            if (!this.demoCheck()) return;
            
            this.masterKey = await this.dispatchWaitAndNotify('getTeamMasterKey', null, false, true);

            let response = await axios.post('https://api.hub.bookblock.com/setup?teamId=' + this.team.id, {apiKey: this.masterKey});
            if (response.data!='OK') {
                console.log(response);
                alert({type: 'error', title: 'HubSpot Connection Error #02', text: 'Unable to connect to HubSpot at this time.'});
                return;
            }
            if (!this.hubspot.connectURL) {
                alert({type: 'error', title: 'HubSpot Connection Error #03', text: 'Unable to connect to HubSpot at this time.'});
                return;
            }
            window.location.href = this.hubspot.connectURL;
        },
        async disconnectFromHubspot() {        
            if (!this.demoCheck()) return;
                
            this.$wait.start('hubspot');
            try {
                let response = await axios.get('https://api.hub.bookblock.com/hubspot/oauth/disconnect?teamId=' + this.team.id );
                alert({type: 'success', title: 'HubSpot Disconnect Success', text: 'You have been disconnected from hubspot successfully.'});
                this.dispatchWaitAndNotify('deleteTeamIntegration', { integration: 'hubspot' }, false, true);
                this.fetchStatuses();
    		} catch (e) {
                console.log(e);
                alert({type: 'error', title: 'HubSpot Disconnect Error', text: 'Unable to disconnect from HubSpot at this time.'});
            }
            this.$wait.end('hubspot');
        },
        async processParams() {            
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            if (params && params.integration && params.connection) {
                if (params.integration == 'hubspot') {
                    if (params.connection == 'false') {
                        alert({type: 'error', title: 'HubSpot Connection Error', text: params.message?params.message:'Unable to connect at this time.'});
                    }
                    if (params.connection == 'true') {
                        alert({type: 'success', title: 'HubSpot Connection Success', text: params.message?params.message:'You have been connected to hubspot successfully.'});
                        this.dispatchWaitAndNotify('addTeamIntegration', { integration: 'hubspot' }, false, true);
                    }
                }
            }
        },
        async fetchStatuses() {
            if (!this.demoCheck()) return;
            
            var response = null;
            try {
                response = await axios.get('https://api.hub.bookblock.com/hubspot/oauth/status?teamId=' + this.team.id + '&userId=' + this.user.user_id );
    		} catch (e) {
                console.log(e);
                alert({type: 'error', title: 'HubSpot Status Error', text: 'Unable to verify the status of your HubSpot connection at this time.'});
            }
            this.hubspot.status = 'unknown';
            if (response && response.data) {
                if (response.data.installUrl) this.hubspot.connectURL = response.data.installUrl;
                if (response.data.isConnected) this.hubspot.status = 'connected';
                else this.hubspot.status = 'disconnected';
            }
        },

        openApiKeyModal() {
            if (!this.proCheck('Generating and using API keys')) return;
            this.modals.apiKeyModal = true;
        },
        async deleteApiKey(id) {
            if (!this.demoCheck()) return;
            
            if (!confirm('Are you sure you want to delete this API Key? This can not be undone.')) {
                return;
            }
            await this.dispatchWaitAndNotify('deleteTeamApiKey', id);
        },
    },
    async mounted() {
        if (!this.demoCheck()) return;
        
        this.processParams();
        await this.dispatchWaitAndNotify('fetchTeamApiKeys', null, false, true);
    },
    computed: {
        apiKeys() {
            return this.$store.state.team.apiKeys;
        },
        team() {
            return this.$store.state.team.detail;
        },
        user() {
            return this.$store.state.currentUser;
        },
        modals() {
            return this.$store.state.modals;
        },
        coreLoaded() { return this.$store.state.coreLoaded }
    },
    watch: {
        coreLoaded() {
            this.fetchStatuses();
        }
    },
}
</script>
<style scoped>
.api-key {
    font-family: monospace;
    background: #eee;
    padding: 5px 8px;
    border-radius: 5px;
    font-size: 12px;
}
</style>
